import { render, staticRenderFns } from "./KpiTiles.vue?vue&type=template&id=1190dbcd&scoped=true"
import script from "./KpiTiles.vue?vue&type=script&lang=js"
export * from "./KpiTiles.vue?vue&type=script&lang=js"
import style0 from "./KpiTiles.vue?vue&type=style&index=0&id=1190dbcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1190dbcd",
  null
  
)

export default component.exports